export const SEARCH_INPUT_HEIGHT = 32

export const ACCOUNTS_PRIVATE = 'own'

export const ACCOUNTS_CORPORATE = 'corporate'

export const ACCOUNTS_SHARED = 'shared'

export const NEED_RECONNECT = 'need_reconnect'

export const EMAIL_CLIENT = 'work_as_email_client'

export const FOLDER_ITEM_KEYS = {
  label: 'title',
  value: 'name',
}

export const ITEM_KEYS = {
  activeKey: 'is_active',
  countKey: 'unread',
  reconnect: NEED_RECONNECT,
  selectedKey: 'id',
  titleKey: 'description',
}

export const SECTION_GROUP_TITLE = {
  [ACCOUNTS_CORPORATE]: 'Email.MailAccountsCorporate',
  [ACCOUNTS_PRIVATE]: 'Email.MailAccountsPrivate',
  [ACCOUNTS_SHARED]: 'Email.MailAccountsShared',
}

export const EMAIL_SUB_MENU_ACCOUNTS_MENU_NO_COUNT_PARAM = { count_unread: 0 }

export const QA_NAME_EMAIL_SUB_MENU = 'emails'

export const FILTER_NAME_ACCOUNT = 'email_account'
